import {observer} from 'mobx-react-lite'
import React from 'react'
import {
  useTaskStore
} from '@components/my-tasks/tasks-list/task-store'
import {UserIcon} from '@extensions/sticker/views-web/user/user-sticker-state'

export const TaskAuthorColumn = observer(() => {
  const [state] = useTaskStore()

  const authorId = state?.author?.id;

  return (
    authorId ? <UserIcon userId={authorId} hideTitle={true} /> : null
  )
})
